import {EBOOK_COVER_ABC, EBOOK_COVER_CREDIT_CAPACITY, EBOOK_COVER_PRIMARY_MARKET_GUIDE, EBOOK_COVER_PURCHASE_MISTAKES} from "./ebook_covers";

export const EBOOK_PDF_FILE_NAMES = {
    abc: "ABC_ebook_RP_new_2.pdf",
    creditCapacity: "20_sposobow_na_poprawe_zdolnosci_kredytowych_v2.pdf",
    primaryMarketGuide: "ebook_przewodnik_jak_kupic_mieszkanie_na_rynku_pierwotnym.pdf",
    purchaseMistakes: "ebook_20_bledow_przy_zakupie_mieszkania_v2.pdf"
} as const;

export interface IEbook {
    cover: string;
    id: string;
    pdfFileName: string;
    title: string;
}

export const EBOOKS: readonly IEbook[] = [
    {
        cover: EBOOK_COVER_PRIMARY_MARKET_GUIDE,
        id: "primary-market-guide",
        pdfFileName: EBOOK_PDF_FILE_NAMES.primaryMarketGuide,
        title: "Jak kupić mieszkanie na Rynku Pierwotnym"
    },
    {
        cover: EBOOK_COVER_PURCHASE_MISTAKES,
        id: "purchase-mistakes",
        pdfFileName: EBOOK_PDF_FILE_NAMES.purchaseMistakes,
        title: "20 błędów przy zakupie mieszkania - darmowy ebook"
    },
    {
        cover: EBOOK_COVER_CREDIT_CAPACITY,
        id: "credit-capacity",
        pdfFileName: EBOOK_PDF_FILE_NAMES.creditCapacity,
        title: "20 sposobów na poprawę zdolności kredytowej - darmowy ebook"
    },
    {
        cover: EBOOK_COVER_ABC,
        id: "abc-home-buying",
        pdfFileName: EBOOK_PDF_FILE_NAMES.abc,
        title: "ABC kupna mieszkania - darmowy ebook"
    }
];
import {EBOOK_COVER_ABC, EBOOK_COVER_CREDIT_CAPACITY, EBOOK_COVER_PRIMARY_MARKET_GUIDE, EBOOK_COVER_PURCHASE_MISTAKES} from "./ebook_covers";

export const EBOOK_PDF_FILE_NAMES = {
    abc: "ABC_ebook_RP_new_2.pdf",
    creditCapacity: "20_sposobow_na_poprawe_zdolnosci_kredytowych_v2.pdf",
    primaryMarketGuide: "ebook_przewodnik_jak_kupic_mieszkanie_na_rynku_pierwotnym.pdf",
    purchaseMistakes: "ebook_20_bledow_przy_zakupie_mieszkania_v2.pdf"
} as const;

export interface IEbook {
    cover: string;
    id: string;
    pdfFileName: string;
    title: string;
}

export const EBOOKS: readonly IEbook[] = [
    {
        cover: EBOOK_COVER_PRIMARY_MARKET_GUIDE,
        id: "primary-market-guide",
        pdfFileName: EBOOK_PDF_FILE_NAMES.primaryMarketGuide,
        title: "Jak kupić mieszkanie na Rynku Pierwotnym"
    },
    {
        cover: EBOOK_COVER_PURCHASE_MISTAKES,
        id: "purchase-mistakes",
        pdfFileName: EBOOK_PDF_FILE_NAMES.purchaseMistakes,
        title: "20 błędów przy zakupie mieszkania - darmowy ebook"
    },
    {
        cover: EBOOK_COVER_CREDIT_CAPACITY,
        id: "credit-capacity",
        pdfFileName: EBOOK_PDF_FILE_NAMES.creditCapacity,
        title: "20 sposobów na poprawę zdolności kredytowej - darmowy ebook"
    },
    {
        cover: EBOOK_COVER_ABC,
        id: "abc-home-buying",
        pdfFileName: EBOOK_PDF_FILE_NAMES.abc,
        title: "ABC kupna mieszkania - darmowy ebook"
    }
];
